interface ProjectFolderIconProps {
  className?: string;
}

export function ProjectFolderIcon({ className = "" }: ProjectFolderIconProps) {
  return (
    <span className={`project-folder${className ? ` ${className}` : ""}`} aria-hidden="true">
      <span />
    </span>
  );
}
